<div
  class="gw-flex gw-min-h-0 gw-w-full gw-flex-1 gw-flex-col gw-gap-medium gw-text-small"
>
  <span
    class="gw-flex gw-min-w-0 gw-mb-small gw-flex-1 gw-items-center gw-gap-small gw-text-text-primary gw-text-[24px] gw-leading-snug"
  >
    {{ titleKey | translate }}
  </span>

  <div
    class="gw-relative gw-min-h-[240px] gw-w-full gw-overflow-hidden gw-rounded-xl gw-bg-background-elevation-2"
  >
    <video
      #preview
      class="gw-h-full gw-w-full gw-object-cover"
      [class.gw-hidden]="permissionDenied"
      muted
      playsinline
    ></video>

    <div
      *ngIf="permissionDenied"
      class="gw-flex gw-min-h-[200px] gw-flex-col gw-items-center gw-justify-center gw-gap-small gw-p-medium gw-text-center"
    >
      <gatewee-icon
        icon="@phi.camera-slash"
        size="32px"
        iconStyle="secondary"
      ></gatewee-icon>
      <p class="gw-m-0 gw-text-[14px] gw-text-text-secondary">
        {{ permissionDeniedKey | translate }}
      </p>
    </div>

    <div
      *ngIf="scanning && !permissionDenied"
      class="gw-pointer-events-none gw-absolute gw-inset-0 gw-flex gw-items-center gw-justify-center"
      aria-hidden="true"
    >
      <div
        class="gw-h-[180px] gw-w-[180px] gw-rounded-lg gw-border-2 gw-border-accent-primary gw-opacity-80"
      ></div>
    </div>
  </div>
</div>
